import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { useAuthStore } from "../stores/authStore";
import Home from "@/views/Home.vue";
import MFA from "@/views/MFA.vue";
import Auth0Callback from "@/views/Auth0Callback.vue";
import Auth0Logout from "../views/Auth0Logout.vue";
import Auth from "@/views/Auth.vue";

const publicPaths = new Set(["/auth", "/auth0callback", "/auth0logout"]);

const routes: Array<RouteRecordRaw> = [
  { path: "/", component: Home },
  { path: "/mfa", component: MFA },
  { path: "/auth0callback", component: Auth0Callback },
  { path: "/auth0logout", component: Auth0Logout },
  { path: "/auth", component: Auth },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path === "/auth0callback") {
    const authStore = useAuthStore();
    await authStore.handleAuth0Callback();
    router.replace("/mfa");
  } else if (to.path === "/auth0logout") {
    const authStore = useAuthStore();
    const reason = (to.query.reason as string) || "logout";

    const existing = localStorage.getItem("auth0_logout_claimed");
    const alreadyClaimed =
      existing !== null && Date.now() - JSON.parse(existing).t < 10000;

    if (alreadyClaimed) {
      localStorage.removeItem("authState");
      localStorage.removeItem("mfaState");
      next(`/auth?reason=${reason}`);
      return;
    }

    localStorage.setItem("auth0_logout_claimed", JSON.stringify({ t: Date.now() }));
    authStore.logout(reason);
    return;
  }

  if (!publicPaths.has(to.path)) {
    const authStore = useAuthStore();
    if (!authStore.isAuthenticated) {
      next("/auth");
      return;
    }
  }

  const regex = /\/apps\/\w+/;
  if (regex.test(to.fullPath)) {
    const url = to.fullPath.match(regex)?.[0] || "";
    window.location.href = `${window.location.origin}${url}`;
  }

  next();
});

export default router;
